/* eslint-disable react-hooks/exhaustive-deps */
// TODO: Move these event listeners into a saga and pull the status from the store
import React, { useEffect, useState, useRef } from 'react'
import { connect } from 'react-redux'

import { getIsPrintController } from '../selectors/config'

import PrintIndicator from '../components/PrintIndicator'

const mapStateToProps = (state) => {
  const available = getIsPrintController(state)

  return { available }
}

export default connect(mapStateToProps, null)(PrintIndicator)
